// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tns-outer {
  padding: 0 !important;
}
.tns-outer [hidden] {
  display: none !important;
}
.tns-outer [aria-controls],
.tns-outer [data-action] {
  cursor: pointer;
}
.tns-slider {
  transition: all 0s;
}
.tns-slider > .tns-item {
  box-sizing: border-box;
}
.tns-horizontal.tns-subpixel {
  white-space: nowrap;
}
.tns-horizontal.tns-subpixel > .tns-item {
  display: inline-block;
  vertical-align: top;
  white-space: normal;
}
.tns-horizontal.tns-no-subpixel:after {
  content: '';
  display: table;
  clear: both;
}
.tns-horizontal.tns-no-subpixel > .tns-item {
  float: left;
}
.tns-horizontal.tns-carousel.tns-no-subpixel > .tns-item {
  margin-right: -100%;
}
.tns-no-calc {
  position: relative;
  left: 0;
}
.tns-gallery {
  position: relative;
  left: 0;
  min-height: 1px;
}
.tns-gallery > .tns-item {
  position: absolute;
  left: -100%;
  transition: transform 0s, opacity 0s;
}
.tns-gallery > .tns-slide-active {
  position: relative;
  left: auto !important;
}
.tns-gallery > .tns-moving {
  transition: all 0.25s;
}
.tns-autowidth {
  display: inline-block;
}
.tns-lazy-img {
  transition: opacity 0.6s;
  opacity: 0.6;
}
.tns-lazy-img.tns-complete {
  opacity: 1;
}
.tns-ah {
  transition: height 0s;
}
.tns-ovh {
  overflow: hidden;
}
.tns-visually-hidden {
  position: absolute;
  left: -10000em;
}
.tns-transparent {
  opacity: 0;
  visibility: hidden;
}
.tns-fadeIn {
  opacity: 1;
  filter: alpha(opacity=100);
  z-index: 0;
}
.tns-normal,
.tns-fadeOut {
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}
.tns-vpfix {
  white-space: nowrap;
}
.tns-vpfix > div,
.tns-vpfix > li {
  display: inline-block;
}
.tns-t-subp2 {
  margin: 0 auto;
  width: 310px;
  position: relative;
  height: 10px;
  overflow: hidden;
}
.tns-t-ct {
  width: 2333.3333333%;
  width: calc(100% * 70 / 3);
  position: absolute;
  right: 0;
}
.tns-t-ct:after {
  content: '';
  display: table;
  clear: both;
}
.tns-t-ct > div {
  width: 1.4285714%;
  width: calc(100% / 70);
  height: 10px;
  float: left;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/tiny-slider.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,eAAe;AACjB;AACA;EAGE,kBAAkB;AACpB;AACA;EAGE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EAGX,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EAGE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EAGE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EAGE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;EAGpB,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;EAGjB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".tns-outer {\n  padding: 0 !important;\n}\n.tns-outer [hidden] {\n  display: none !important;\n}\n.tns-outer [aria-controls],\n.tns-outer [data-action] {\n  cursor: pointer;\n}\n.tns-slider {\n  -webkit-transition: all 0s;\n  -moz-transition: all 0s;\n  transition: all 0s;\n}\n.tns-slider > .tns-item {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.tns-horizontal.tns-subpixel {\n  white-space: nowrap;\n}\n.tns-horizontal.tns-subpixel > .tns-item {\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n}\n.tns-horizontal.tns-no-subpixel:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.tns-horizontal.tns-no-subpixel > .tns-item {\n  float: left;\n}\n.tns-horizontal.tns-carousel.tns-no-subpixel > .tns-item {\n  margin-right: -100%;\n}\n.tns-no-calc {\n  position: relative;\n  left: 0;\n}\n.tns-gallery {\n  position: relative;\n  left: 0;\n  min-height: 1px;\n}\n.tns-gallery > .tns-item {\n  position: absolute;\n  left: -100%;\n  -webkit-transition: transform 0s, opacity 0s;\n  -moz-transition: transform 0s, opacity 0s;\n  transition: transform 0s, opacity 0s;\n}\n.tns-gallery > .tns-slide-active {\n  position: relative;\n  left: auto !important;\n}\n.tns-gallery > .tns-moving {\n  -webkit-transition: all 0.25s;\n  -moz-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.tns-autowidth {\n  display: inline-block;\n}\n.tns-lazy-img {\n  -webkit-transition: opacity 0.6s;\n  -moz-transition: opacity 0.6s;\n  transition: opacity 0.6s;\n  opacity: 0.6;\n}\n.tns-lazy-img.tns-complete {\n  opacity: 1;\n}\n.tns-ah {\n  -webkit-transition: height 0s;\n  -moz-transition: height 0s;\n  transition: height 0s;\n}\n.tns-ovh {\n  overflow: hidden;\n}\n.tns-visually-hidden {\n  position: absolute;\n  left: -10000em;\n}\n.tns-transparent {\n  opacity: 0;\n  visibility: hidden;\n}\n.tns-fadeIn {\n  opacity: 1;\n  filter: alpha(opacity=100);\n  z-index: 0;\n}\n.tns-normal,\n.tns-fadeOut {\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n.tns-vpfix {\n  white-space: nowrap;\n}\n.tns-vpfix > div,\n.tns-vpfix > li {\n  display: inline-block;\n}\n.tns-t-subp2 {\n  margin: 0 auto;\n  width: 310px;\n  position: relative;\n  height: 10px;\n  overflow: hidden;\n}\n.tns-t-ct {\n  width: 2333.3333333%;\n  width: -webkit-calc(100% * 70 / 3);\n  width: -moz-calc(100% * 70 / 3);\n  width: calc(100% * 70 / 3);\n  position: absolute;\n  right: 0;\n}\n.tns-t-ct:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.tns-t-ct > div {\n  width: 1.4285714%;\n  width: -webkit-calc(100% / 70);\n  width: -moz-calc(100% / 70);\n  width: calc(100% / 70);\n  height: 10px;\n  float: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
